import React from "react";
import { Circle, Group, Line } from "react-konva";

const ExistingFence = ({ shape, shapeProps }) => {
	return (
		<Group {...shapeProps} key={shape.id}>
			<Line
				points={shape.points}
				stroke={shape.type === "tearOutFence" ? "red" : "black"}
				strokeWidth={2}
				dash={
					["tearOutFence", "existingFence"].includes(shape.type) ? [5, 2] : []
				}
			/>
			<Circle
				x={shape.points[0]}
				y={shape.points[1]}
				radius={5}
				fill="white"
				stroke="red"
				strokeWidth={2}
			/>
			<Circle
				x={shape.points[2]}
				y={shape.points[3]}
				radius={5}
				fill="white"
				stroke="red"
				strokeWidth={2}
			/>
		</Group>
	);
};

export default ExistingFence;
